import { LoadingRows } from "../UI/Loading/LoadingRows.tsx";
import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../UI/Card.tsx";
import { useAllUserGroups } from "./useAllUserGroups.ts";
import { useToCreateUserGroupScreen } from "./useToCreateUserGroupScreen.ts";
import { useNavigate } from "react-router-dom";
import { EditUserGroupScreenPath } from "./EditUserGroupScreen.tsx";

export const AllUserGroupsScreenPath = "/user-groups";

export function AllUserGroupsScreen() {
  const { userGroups, loading } = useAllUserGroups();
  const { toCreateUserGroup } = useToCreateUserGroupScreen();
  const navigate = useNavigate();

  return (
    <Layout>
      <Card>
        <ScreenTitleBlock
          title={"User Groups"}
          ctaLabel={"New Group"}
          ctaOnClick={toCreateUserGroup}
        />
      </Card>
      <div className={"mt-4"}>
        <Card>
          {loading ? (
            <LoadingRows />
          ) : (
            <div className={"divide-y"}>
              {userGroups.length === 0 ? (
                <div className={"text-sm text-slate-500 p-4"}>
                  No groups found.
                </div>
              ) : (
                userGroups.map((g) => (
                  <div
                    key={g.id}
                    onClick={() =>
                      navigate(
                        EditUserGroupScreenPath.replace(":userGroupId", g.id),
                      )
                    }
                    className={
                      "p-4 flex items-center justify-between cursor-pointer hover:bg-slate-50"
                    }
                  >
                    <div className={"flex items-center gap-2"}>
                      <span className={"font-medium"}>{g.name}</span>
                      {g.onboardingLiveRequired ? (
                        <span
                          className={
                            "inline-flex items-center rounded-full bg-fuchsia-100 px-2 py-0.5 text-xs font-medium text-fuchsia-700"
                          }
                        >
                          Live onboarding obbligatoria ·{" "}
                          {g.onboardingLiveBookingWindowDays} giorni
                        </span>
                      ) : null}
                    </div>
                    <div className={"text-xs text-slate-400"}>{g.slug}</div>
                  </div>
                ))
              )}
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
}
